import type { Name } from 'sr-types/lib/search/v1/graphql';

/**
 * Formats a name object into a full name string.
 * @param name The name object to format
 * @returns Formatted name string
 */
export const getContactNameFromObject = (name: Name | null = {}): string => {
    const firstName = name?.firstName ?? '';
    const lastName = name?.lastName ?? '';
    const contactName = `${firstName} ${lastName}`.trim();
    return contactName;
};
